<template>
  <div class="w-full min-h-screen bg-gradient-to-br from-gray-25 to-gray-50 p-2 rounded-lg">
    <!-- Header -->
    <div class="mb-4">
      <div class="flex items-start justify-between bg-white p-4 rounded-lg mb-2">
        <div class="ml-5">
          <div class="flex items-center gap-3 mb-2">
            <div class="w-2 h-8 bg-gradient-to-b from-blue-500 to-blue-600 rounded-full"></div>
            <h1 class="text-2xl font-bold text-gray-900 tracking-tight">سود خالص (ماهانه)</h1>
          </div>
        </div>
        <div class="flex items-center gap-1">
          <button
              style="max-width: 100px"
              @click="refresh"
              :disabled="isLoading"
              class="flex items-center justify-center w-8 h-8 rounded-lg bg-blue-500 text-white text-sm font-semibold transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed shadow-xs"
              title="بروزرسانی"
          >
            <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
            </svg>
            بروزرسانی
          </button>
          <!--
          <button
              @click="exportCSV"
              :disabled="isLoading"
              class="flex items-center justify-center w-8 h-8 rounded-lg bg-green-600 text-white text-sm font-semibold transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed shadow-xs"
              title="خروجی CSV"
          >
            <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            </svg>
          </button>
          -->
        </div>
      </div>

      <div class="bg-white p-2 rounded-lg mb-2">
        <div class="flex flex-wrap items-center gap-2 mb-3">
          <span class="text-[11px] text-gray-700 mr-1">انتخاب بازه:</span>

          <div class="inline-flex items-center bg-gray-100 rounded-lg p-1 shadow-xs">
            <button
                @click="applyPreset('current_month')"
                :class="[
                'px-3 py-1.5 text-lg m-2 rounded-lg font-medium',
                monthly.mode==='current_month'
                  ? 'bg-gray-700 text-gray-50'
                  : ' bg-white text-gray-900 '
              ]"
            >
              ماه جاری
            </button>

            <button
                @click="applyPreset('previous_month')"
                :class="[
                'px-3 py-1.5 text-lg m-2 rounded-lg font-medium',
                monthly.mode==='previous_month'
                  ? 'bg-gray-700 text-gray-50'
                  : ' bg-white text-gray-900 '
              ]"
            >
              ماه قبل
            </button>

            <button
                @click="switchToRange"
                :class="[
                'px-3 py-1.5 text-lg m-2 rounded-lg font-medium',
                monthly.mode==='range'
                  ? 'bg-gray-700 text-gray-50'
                  : ' bg-white text-gray-900 '
              ]"
            >
              بازه دلخواه
            </button>
          </div>
        </div>

        <div v-if="monthly.mode==='range'" class="flex flex-wrap items-end gap-3">
          <div class="bg-gray-100 rounded-lg p-1 flex flex-wrap items-center">
            <div class="flex flex-col">
              <label class="text-[11px] text-gray-600 mb-1">از سال</label>
              <input
                  v-model="monthly.from_year"
                  type="number"
                  inputmode="numeric"
                  pattern="\\d*"
                  placeholder="مثل 1403"
                  class="px-3 py-2 text-sm rounded-lg ring-2 ring-blue-400 bg-white w-28"
              />
            </div>
            <div class="flex flex-col">
              <label class="text-[11px] text-gray-600 mb-1">از ماه</label>
              <select v-model="monthly.from_month"
                      class="px-3 py-2 text-sm rounded-lg ring-2 ring-blue-400 bg-white w-28">
                <option v-for="m in months" :key="'from-'+m.value" :value="m.value">{{ m.label }}</option>
              </select>
            </div>
          </div>

          <div class="bg-gray-100 rounded-lg p-1 flex flex-wrap items-center">
            <div class="flex flex-col mr-2">
              <label class="text-[11px] text-gray-600 mb-1">تا سال</label>
              <input
                  v-model="monthly.to_year"
                  type="number"
                  inputmode="numeric"
                  pattern="\\d*"
                  placeholder="مثل 1404"
                  class="px-3 py-2 text-sm rounded-lg ring-2 ring-blue-400 bg-white w-28"
              />
            </div>
            <div class="flex flex-col">
              <label class="text-[11px] text-gray-600 mb-1">تا ماه</label>
              <select v-model="monthly.to_month"
                      class="px-3 py-2 text-sm rounded-lg ring-2 ring-blue-400 bg-white w-28">
                <option v-for="m in months" :key="'to-'+m.value" :value="m.value">{{ m.label }}</option>
              </select>
            </div>
          </div>

          <div class="flex items-center gap-2">
            <button
                class="px-4 py-2 text-xs rounded-lg bg-blue-600 text-white hover:bg-blue-700"
                @click="applyMonthlyFilters"
                :disabled="isLoading">
              اعمال فیلتر
            </button>
            <button
                class="px-3 py-2 text-xs rounded-lg border hover:bg-gray-50"
                @click="resetMonthly"
                :disabled="isLoading">
              بازنشانی (ماه جاری)
            </button>
          </div>

          <div class="text-xs text-gray-500 ml-auto" v-if="netMonthly.months_count">
            تعداد ماه‌ها: <b class="text-gray-800">{{ netMonthly.months_count }}</b>
          </div>
        </div>

        <p v-if="validationError" class="text-xs text-red-600 mt-2">{{ validationError }}</p>
      </div>
    </div>

    <!-- Summary + Breakdown -->
    <div class="grid grid-cols-12 gap-6">
      <div class="col-span-12">
        <div class="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
          <!-- Summary -->
          <div v-if="loading.net_profit" class="animate-pulse">
            <div class="h-4 w-40 bg-gray-200 rounded mb-3"></div>
            <div class="h-4 w-full bg-gray-200 rounded"></div>
          </div>

          <div v-else class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 text-center">
            <div class="p-4 rounded-xl bg-blue-50">
              <div class="text-[11px] text-blue-700 mb-1">جمع سود ناخالص بازه</div>
              <div class="text-lg font-bold">{{ formatCurrency(netMonthly.gross_profit) }}</div>
            </div>
            <div class="p-4 rounded-xl bg-amber-50">
              <div class="text-[11px] text-amber-700 mb-1">هزینه ثابت ماهانه × {{ netMonthly.months_count }}</div>
              <div class="text-lg font-bold">{{ formatCurrency(netMonthly.fixed_cost_total) }}</div>
              <div class="text-[11px] text-amber-700 mt-1">مبنای ماهانه: {{ formatCurrency(netMonthly.fixed_cost_base) }}</div>
            </div>
            <div class="p-4 rounded-xl bg-rose-50">
              <div class="text-[11px] text-rose-700 mb-1">هزینه‌های متغیر</div>
              <div class="text-lg font-bold">{{ formatCurrency(netMonthly.variable_costs.total) }}</div>
              <div class="text-[11px] text-rose-700 mt-1">
                هزینه های مازاف: {{ formatCurrency(netMonthly.variable_costs.extra) }} +
                پست : {{ formatCurrency(netMonthly.variable_costs.shipping) }}
              </div>
            </div>
            <div class="p-4 rounded-xl bg-emerald-50">
              <div class="text-[11px] text-emerald-700 mb-1">سود خالص بازه</div>
              <div class="text-lg font-bold">{{ formatCurrency(netMonthly.net_profit) }}</div>
            </div>
          </div>

          <!-- Divider -->
          <div class="my-6 h-px bg-gray-100"></div>

          <!-- Breakdown -->
          <div class="flex items-center justify-between mb-2">
            <h4 class="text-xs text-gray-600 font-medium">ریز ماه‌به‌ماه</h4>
            <span class="text-[11px] text-gray-500" v-if="netMonthly.partial_current">ماه جاری به‌صورت Partial</span>
          </div>

          <div v-if="loading.net_profit_breakdown" class="animate-pulse space-y-2">
            <div class="h-4 bg-gray-200 rounded"></div>
            <div class="h-4 bg-gray-200 rounded"></div>
            <div class="h-4 bg-gray-200 rounded"></div>
          </div>

          <div v-else>
            <div class="overflow-x-auto -mx-4 sm:mx-0">
              <table class="min-w-full text-xs">
                <thead>
                <tr class="text-gray-500">
                  <th class="text-right py-2 pr-4">ماه</th>
                  <th class="text-left py-2">سود ناخالص</th>
                  <th class="text-left py-2">هزینه ثابت ماهانه</th>
                  <th class="text-left py-2">هزینه‌های متغیر</th>
                  <th class="text-left py-2">سود خالص</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="r in netMonthlyRows" :key="r.jy+'-'+r.jm" class="border-t text-gray-700">
                  <td class="py-2 pr-4">{{ r.jy }}-{{ pad2(r.jm) }}</td>
                  <td class="py-2 text-left">{{ formatCurrency(r.gross_profit) }}</td>
                  <td class="py-2 text-left">{{ formatCurrency(r.fixed_cost_base) }}</td>
                  <td class="py-2 text-left">
                    {{ formatCurrency(r.variable_costs.total) }}
                    <span class="text-[10px] text-gray-400">
                      (هزینه های مازاف: {{ formatCurrency(r.variable_costs.extra) }} + پست : {{ formatCurrency(r.variable_costs.shipping) }})
                    </span>
                  </td>
                  <td class="py-2 text-left font-medium">{{ formatCurrency(r.net_profit) }}</td>
                </tr>
                <tr v-if="!netMonthlyRows.length">
                  <td colspan="6" class="py-6 text-center text-gray-400">داده‌ای برای نمایش نیست</td>
                </tr>
                </tbody>
                <tfoot v-if="netMonthlyRows.length" class="text-gray-900">
                <tr class="border-t">
                  <td class="py-2 pr-4 font-semibold">جمع بازه</td>
                  <td class="py-2 text-left font-semibold">{{ formatCurrency(netMonthly.summary.gross_profit) }}</td>
                  <td class="py-2 text-left font-semibold">{{ formatCurrency(netMonthly.summary.fixed_cost_total) }}</td>
                  <td class="py-2 text-left font-semibold">{{ formatCurrency(netMonthly.summary.variable_cost_total) }}</td>
                  <td class="py-2 text-left font-semibold">{{ formatCurrency(netMonthly.summary.net_profit) }}</td>
                </tr>
                </tfoot>
              </table>
            </div>

            <div v-if="errorMessage" class="mt-6 p-4 bg-red-50 border border-red-200 rounded-xl">
              <div class="flex items-center gap-3 text-red-700">
                <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 0 0118 0z"/>
                </svg>
                <div>
                  <p class="text-sm font-medium">{{ errorMessage }}</p>
                  <p class="text-xs mt-1">لطفاً دوباره تلاش کنید یا با پشتیبانی تماس بگیرید</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NetProfitMonthly',
  data() {
    return {
      months: [
        { value: '01', label: 'فروردین' },
        { value: '02', label: 'اردیبهشت' },
        { value: '03', label: 'خرداد' },
        { value: '04', label: 'تیر' },
        { value: '05', label: 'مرداد' },
        { value: '06', label: 'شهریور' },
        { value: '07', label: 'مهر' },
        { value: '08', label: 'آبان' },
        { value: '09', label: 'آذر' },
        { value: '10', label: 'دی' },
        { value: '11', label: 'بهمن' },
        { value: '12', label: 'اسفند' },
      ],

      // حالت/فیلتر
      monthly: {
        mode: 'current_month', // 'current_month' | 'previous_month' | 'range'
        from_year: '',
        from_month: '',
        to_year: '',
        to_month: '',
      },

      // خروجی
      netMonthly: {
        months_count: 0,
        sales_gross: 0,
        fixed_cost_base: 0,
        fixed_cost_total: 0,
        variable_costs: { extra: 0, shipping: 0, total: 0 },
        net_profit: 0,
        partial_current: false,
        summary: { sales_gross: 0, fixed_cost_total: 0, variable_cost_total: 0, net_profit: 0 },
      },
      netMonthlyRows: [],

      // وضعیت
      loading: {
        net_profit: false,
        net_profit_breakdown: false,
      },
      errorMessage: '',
      validationError: '',
    }
  },
  computed: {
    isLoading() {
      return this.loading.net_profit || this.loading.net_profit_breakdown
    },
    displayRangeLabel() {
      if (this.monthly.mode === 'current_month') return 'ماه جاری'
      if (this.monthly.mode === 'previous_month') return 'ماه قبل'
      const { from_year: fy, from_month: fm, to_year: ty, to_month: tm } = this.monthly
      if (fy && fm && ty && tm) return `${fy}-${fm} تا ${ty}-${tm}`
      return '—'
    },
  },
  mounted() {
    // دیفالت: ماه جاری
    this.applyPreset('current_month')
  },
  methods: {
    // ---- Helpers ----
    pad2(n) { return String(n).padStart(2, '0') },
    formatCurrency(val) {
      if (val == null) return '0'
      return Number(val).toLocaleString('fa-IR')
    },

    // تغییر به بازه دلخواه (بدون فراخوانی API تا وقتی اعمال نشه)
    switchToRange() {
      this.monthly.mode = 'range'
    },

    // اعمال فوری پریست‌ها
    applyPreset(preset) {
      this.validationError = ''
      this.monthly.mode = preset // 'current_month' یا 'previous_month'
      const params = { preset }
      this.fetchNetProfitMonthly(params, ({ months }) => {
        // فرم را با ماه‌های پاسخ هم همگام نگه می‌داریم (برای CSV/نمایش)
        if (months && months.length) {
          const first = months[0]
          const last = months[months.length - 1]
          this.monthly.from_year = String(first.jy)
          this.monthly.from_month = String(first.jm).padStart(2, '0')
          this.monthly.to_year = String(last.jy)
          this.monthly.to_month = String(last.jm).padStart(2, '0')
        }
      })
      this.fetchNetProfitMonthlyBreakdown(params)
    },

    // ساخت پارامتر API برای بازه
    buildParamsForRange() {
      this.validationError = ''
      const { from_year, from_month, to_year, to_month } = this.monthly
      if (!from_year || !from_month || !to_year || !to_month) {
        this.validationError = 'سال/ماه شروع و پایان الزامی‌اند.'
        return null
      }
      if (!/^\d{4}$/.test(from_year) || !/^\d{4}$/.test(to_year)) {
        this.validationError = 'فرمت سال نامعتبر است (مثل 1404).'
        return null
      }
      const fm = parseInt(from_month, 10)
      const tm = parseInt(to_month, 10)
      const fy = parseInt(from_year, 10)
      const ty = parseInt(to_year, 10)
      if (fm < 1 || fm > 12 || tm < 1 || tm > 12) {
        this.validationError = 'ماه باید بین 01 تا 12 باشد.'
        return null
      }
      const fromKey = fy * 100 + fm
      const toKey = ty * 100 + tm
      if (toKey < fromKey) {
        this.validationError = 'پایان نمی‌تواند قبل از شروع باشد.'
        return null
      }
      return {
        from_jmonth: `${from_year}-${from_month}`,
        to_jmonth: `${to_year}-${to_month}`,
      }
    },

    applyMonthlyFilters() {
      if (this.monthly.mode !== 'range') return
      const params = this.buildParamsForRange()
      if (!params) return
      this.fetchNetProfitMonthly(params)
      this.fetchNetProfitMonthlyBreakdown(params)
    },

    resetMonthly() {
      this.validationError = ''
      this.applyPreset('current_month')
    },

    refresh() {
      if (this.monthly.mode === 'range') {
        const params = this.buildParamsForRange()
        if (!params) return
        this.fetchNetProfitMonthly(params)
        this.fetchNetProfitMonthlyBreakdown(params)
      } else {
        this.applyPreset(this.monthly.mode) // current_month یا previous_month
      }
    },

    // ---- API calls ----
    fetchNetProfitMonthly(params, after = null) {
      this.loading.net_profit = true
      this.errorMessage = ''
      this.request({
        url: this.endpoint('saleReports/reports/profit/net-monthly'),
        method: 'get',
        params,
        success: (data) => {
          this.netMonthly = {
            months_count: data.months_count || 0,
            sales_gross: data.sales_gross || 0,
            fixed_cost_base: data.fixed_cost_base || 0,
            fixed_cost_total: data.fixed_cost_total || 0,
            variable_costs: data.variable_costs || { extra: 0, shipping: 0, total: 0 },
            net_profit: data.net_profit || 0,
            partial_current: !!data.partial_current,
            summary: this.netMonthly.summary, // summary از breakdown می‌آید
          }
          this.loading.net_profit = false
          if (after) after({ months: data.months, partial_current: data.partial_current })
        },
        error: () => {
          this.loading.net_profit = false
          this.errorMessage = 'خطا در دریافت خلاصه سود خالص ماهانه.'
        }
      })
    },

    fetchNetProfitMonthlyBreakdown(params, after = null) {
      this.loading.net_profit_breakdown = true
      this.errorMessage = ''
      this.request({
        url: this.endpoint('saleReports/reports/profit/net-monthly/breakdown'),
        method: 'get',
        params,
        success: (data) => {
          this.netMonthlyRows = data.results || []
          this.netMonthly.summary = data.summary || { sales_gross: 0, fixed_cost_total: 0, variable_cost_total: 0, net_profit: 0 }
          this.netMonthly.partial_current = !!data.partial_current
          this.loading.net_profit_breakdown = false
          if (after) after({ months: data.months, partial_current: data.partial_current })
        },
        error: () => {
          this.netMonthlyRows = []
          this.loading.net_profit_breakdown = false
          this.errorMessage = 'خطا در دریافت ریز ماه‌به‌ماه سود خالص.'
        }
      })
    },

    // ---- Export ----
    exportCSV() {
      const rows = [
        ['metric', 'value'],
        ['sales_gross', this.netMonthly.sales_gross],
        ['fixed_cost_base', this.netMonthly.fixed_cost_base],
        ['fixed_cost_total', this.netMonthly.fixed_cost_total],
        ['variable_extra', (this.netMonthly.variable_costs || {}).extra || 0],
        ['variable_shipping', (this.netMonthly.variable_costs || {}).shipping || 0],
        ['variable_total', (this.netMonthly.variable_costs || {}).total || 0],
        ['net_profit', this.netMonthly.net_profit],
        [],
        ['Month', 'SalesGross', 'FixedMonthly', 'VarTotal', 'VarExtra', 'VarShip', 'Net', 'Partial'],
      ]
      for (const r of this.netMonthlyRows) {
        rows.push([
          `${r.jy}-${this.pad2(r.jm)}`,
          r.sales_gross,
          r.fixed_cost_base,
          r.variable_costs?.total || 0,
          r.variable_costs?.extra || 0,
          r.variable_costs?.shipping || 0,
          r.net_profit,
          r.partial ? '1' : '0',
        ])
      }
      const csv = rows.map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(',')).join('\n')
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `net_profit_monthly.csv`
      a.click()
      URL.revokeObjectURL(url)
    },
  }
}
</script>

<style scoped>
.shadow-xs { box-shadow: 0 1px 2px 0 rgba(0,0,0,0.05); }
.from-gray-25 {
  --tw-gradient-from: #fcfcfd;
  --tw-gradient-to: rgba(252, 252, 253, 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
*{ transition-property: color, background-color, border-color, transform, box-shadow;
  transition-timing-function: cubic-bezier(0.4,0,0.2,1); transition-duration: 150ms; }
button:focus { outline: 2px solid #3b82f6; outline-offset: 2px; }
::-webkit-scrollbar { width: 6px; height: 6px; }
::-webkit-scrollbar-track { background: #f1f5f9; border-radius: 10px; }
::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
</style>
